import enumChoice from "../../enum";
import FilterableForm from "../common/filterableForm";

interface OrderFilterProps {
  onClose: () => void;
}

function OrderFilter({ onClose }: OrderFilterProps) {  

  return (
    
    <FilterableForm
      title="Product Filters"
      fields={[
          { name: "status", label: "status", type: "select", options: enumChoice.orderStatus, defaultValue: "" },
          { name: "charge_status", label: "Charge Status", type: "select", options: enumChoice.chargeStatus, defaultValue: "" },
          { name: "payment_status", label: "Payment Status", type: "select", options: enumChoice.paymentMethods, defaultValue: "" },
          { name: "minOrderValue", label: "Minimum Order Value", type: "number", defaultValue: 0 },
          { name: "maxOrderValue", label: "Maximum Order Value", type: "number", defaultValue: 0 },
          { name: "is_due", label: "Is Due", type: "checkbox", defaultValue: true },
      ]}
      onClose={onClose}
    />

  );
}

export default OrderFilter;
